// extracted by mini-css-extract-plugin
export var container = "styles-module__container___UlaNr";
export var routeHeaderContainer = "styles-module__routeHeaderContainer___oVR5E";
export var routeContainerSubtext = "styles-module__routeContainerSubtext___FhlsR";
export var routeContainerTitle = "styles-module__routeContainerTitle___t7K_E";
export var divider = "styles-module__divider___GTDKL";
export var marginTop = "styles-module__marginTop___s82U1";
export var marginSides = "styles-module__marginSides___qmUPw";
export var spacer = "styles-module__spacer___YklYX";
export var routeDetailsContainer = "styles-module__routeDetailsContainer___uhLAE";
export var staticMapImage = "styles-module__staticMapImage___pVo6I";
export var actionButtons = "styles-module__actionButtons___wT2dY";
export var smaller = "styles-module__smaller___fbxJC";